import { render, staticRenderFns } from "./AnnouncementStatus.vue?vue&type=template&id=0bb51d0b&"
import script from "./AnnouncementStatus.vue?vue&type=script&lang=js&"
export * from "./AnnouncementStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports